// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__14l8C","footer":"ModalInfo_footer__k5am-"};